export default __webpack_public_path__ + "static/media/16.b43c46f5.webp";